import { http } from '@/request';
import { radar } from '@/common/log';
import { localStorage } from '@kibt/krn-utils';

// 后端提供AB接口需求
// https://docs.corp.kuaishou.com/d/home/fcABf5z8o71uzdz-FdSnOl_bK
export interface KeysType {
    [key: string]: 'bool' | 'int' | 'string' | 'long';
}

export async function getAbTestData(keys: KeysType): Promise<{
    [key in keyof KeysType]: {
        value: any;
        groupName: string;
        experimentName: string;
    };
}> {
    try {
        const start = Date.now();
        const res = await http('POST/rest/o/ecommerce/customer/abConf', { body: { keys } }).catch(err => {
            //忽略网络问题的异常
            console.log('err', err);
        });
        const end = Date.now();
        radar.event({ name: 'Shop_C_RN_AB_Res', params: { res, duration: end - start } });
        if (res && res.data && res.data.values) {
            // console.log('AB实验结果', res.data.values);
            return res.data.values as any;
        }
        return {};
    } catch (error) {
        return {};
    }
}

export default getAbTestData;

/**
 * 获取ab信息，注意缓存策略，eg:
 * getAbTestInfo({
 *     key: { krn_spa: 'bool' },
 *     cacheTime: 5 * 1000,
 *     isCache: (res) => re?.krn_spa?.value === true
 * })
 */
export async function getAbTestInfo(params: {
    // ab的key
    key: KeysType;
    // 默认缓存时间为3min
    cacheTime?: number;
    // 缓存
    isCache?: (result: any) => boolean;
}): Promise<{
    [key in keyof KeysType]: {
        value: any;
        groupName: string;
        experimentName: string;
    };
}> {
    const { key, cacheTime = 1000 * 60 * 3, isCache = () => false } = params;
    // 获取本地缓存
    const cacheKey = `ab_cache_keys_${Object.keys(key).join('-')}`;
    const cacheResult = await localStorage.getItem(cacheKey);
    if (cacheResult) {
        try {
            const res = JSON.parse(cacheResult as string) as {
                result: any;
                cacheTime: number;
                cacheStartTime: number;
            };
            // 缓存未过期，返回缓存
            if (res.cacheStartTime + res.cacheTime > Date.now()) {
                return res.result as any;
            }
        } catch (err) {
            console.log('getAbTestInfo error', err);
        }
    }
    // 请求接口
    const res = await getAbTestData(key);
    // 判断是否需要缓存接口结果
    if (isCache(res)) {
        const result = {
            result: res,
            cacheStartTime: Date.now(),
            cacheTime,
        };
        await localStorage.setItem(cacheKey, JSON.stringify(result));
    }
    return res;
}
